<template>
  <div class="home">
    <div class="search-block">
      <div class="search-wrap">
        <p class="title">课元外文数字图书馆</p>
        <div class="input-block">
          <!-- <select class="custom-select" v-model="selectedOption" placeholder="请选择" transfer>
            <option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </option>
          </select> -->
          <a-select dropdownClassName="selector" default-value="TITLE" style="width: 120px" @change="handleChange">
            <a-select-option value="AUTHOR">
              作者
            </a-select-option>
            <a-select-option value="TITLE">
              书名
            </a-select-option>
            <a-select-option value="PUBLISHER">
              出版社
            </a-select-option>
            <a-select-option value="ISSN">
              ISBN
            </a-select-option>
            <a-select-option value="DESCRIPTION">
              内容简介
            </a-select-option>
          </a-select>
  
          <input v-model="searchText" @keydown.enter="search" placeholder="">
          <button class="m-button" @click="search" :disabled="lock">检索</button>
        </div>
        <div class="select-block">
          <div>
            <p>年份检索</p>
            <input v-model="startYear"  type="number" placeholder="起始年">
            <p>到</p>
            <input v-model="endYear"  type="number" placeholder="终止年">
          </div>
        </div>
      </div>

      <img loading="lazy" class="main-img" src="@/assets/readingBook.png">
    </div>

    <div class="hot-list" :class="{ loading : hotLoading}" >
      <p v-show="showWeekContent">一周热榜</p>
        <!-- <div class="img-wrapper"> -->

        <BookShelf :bookList="week" v-show="showWeekContent"></BookShelf>
        <!-- </div> -->

        <!-- <div v-for="book, index in books" :key="book.id" @mouseover="handleMouseOver(book)"
          @mouseout="handleMouseOut(book)">
          <img src="../assets/books/1.png" :class="{ bigger: book.bigger }">
        </div> -->
      <!-- </div> -->
    </div>

    <div class="news-list">
      <div class="top">
        <div class="calender">
          <p>{{ today.year }}</p>
          <p>{{ today.month }} {{ today.date }}</p>
        </div>

        <div class="news">
          <div>
            <div class="header">
              <button class="m-button">重要通知</button>
              <p>更多</p>
            </div>
            <div v-for="item, index in news" :key="index" class="news-item">
              <p class="desc">{{ item.message }}</p>
              <p class="time">{{ item.updatedAt }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="recommend">

        <div class="head">
          <button class="m-button">新书推荐</button>
          <div @click="getRecommend"><img src="../assets/svgs/Redo.svg">换一批</div>
        </div>
        <BookShelf :bookList="recommends" :class="{ loading : recommendLoading}"></BookShelf>

        <!-- <div class="recommend-wrapper"> -->
         
          <!-- <div v-for="book in recommends" :key="book.id" @mouseover="handleMouseOver(book)"
            @mouseout="handleMouseOut(book)">
            <img src="../assets/books/1.png">
            <div class="book-name">{{ book.name }}</div>
          </div> -->
        <!-- </div> -->
      </div>

    </div>
  </div>
</template>

<script>
import { allSearch, getRecommend, getWeekHot } from '@/_api/book'
import { getNotification } from '@/_api/notification'

export default {
  name: 'HomeView',
  data() {
    return {
      showWeekContent: false,
      hotLoading: true,
      showContent: false,
      recommendLoading: true,
      startYear: '',
      endYear: '',
      searchText: '',
      today : {
        year: 2024,
        month: new Date().toLocaleString('en-us', { month: 'short' }).toUpperCase(),
        date: new Date().getDate().toString().padStart(2, '0')
      },
      selectedOption: 'TITLE',
      options: [
        { label: '作者', value: 'AUTHOR' },
        { label: '书名', value: 'TITLE' },
        { label: '出版社', value: 'PUBLISHER' },
        { label: 'ISBN', value: 'ISSN' },
        { label: '内容简介', value: 'DESCRIPTION' },
      ],
      books: [],
      week: [],
      news: [],
      recommends: [],
      pageSize: 10,
      order: 'YEAR',
      page: 1,
      lock: false
    };
  },
  mounted() {
    this.getNotification()
    this.getWeekHot()
    this.getRecommend()
  },
  methods: {
    getNotification() {
      getNotification({
        page: 1,
        size: 10
      }).then((res) => {
        if (res.status == 'ok') {
          this.news = res.data.userNotifications
          this.news  = this.news.slice(0, 5);
        }
        console.log(res)
      })
    },
    getWeekHot() {
      getWeekHot().then((res) => {
        if (res.status == 'ok') {
          this.week = res.data
          this.showWeekContent = true
          for(let i = 0; i < this.week.length ; i++) {
            this.week[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" +this.week[i].coverUrl
          }
        }
      }).finally(() => {
        this.hotLoading = false
      })
    },
    getRecommend() {
      getRecommend().then((res) => {
        if (res.status == 'ok') {
          res.data.results.forEach(recommend => {
            recommend.bookMd5 = recommend.title;
          });
          this.recommends = res.data.results
          for(let i = 0; i < this.recommends.length ; i++) {
            this.recommends[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" +this.recommends[i].coverUrl
          }
        }
      }).finally(() => {
        this.recommendLoading = false
      })
    },
    search() {
      if (this.lock) return
      this.lock = true
      // let searchTerms = '*:*'
      // if (this.searchText.length > 0) {
      //   searchTerms = this.searchText
      // }
      let searchParams = {
        startYear: this.startYear,
        endYear: this.endYear ,
        searchText: this.searchText,
        selectedOption: this.selectedOption,
      }
   
      this.lock = false
      this.$router.push({path: '/main', query: {searchParams: searchParams}})
    },
    routerMain(params, data){
      this.$router.push({
        path: '/main', // 目标路由的路径
        query: { list: data, params: params} // 要传递的参数，以对象形式传递
      });
    },
    handleChange(value) {
      this.selectedOption = value
    },
    handleMouseOver(selectedImage) {
      this.books.forEach(book => {
        book.bigger = book.id === selectedImage.id;
      });
    },
    handleMouseOut() {
      this.books.forEach(book => {
        book.bigger = false;
      });
    },
  }
}
</script>
<style lang="less">
.home {
  background: var(--background-color);
  flex: 1;

  @media screen and (max-width:1050px) {
    background: #FFFFFF;
  }

  .search-block {
    position: relative;
    height: 600px;

    @media screen and (max-width:1050px) {
      height: 550px;
    }

    @media screen and (max-width:520px) {
      height: 600px;
    }

    .search-wrap {
      position: absolute;
      left: 12%;
      top: 200px;
      z-index: 1;

      @media screen and (max-width:1050px) {
        left: 30px;
      }

      @media screen and (max-width:520px) {
        left: 15px;
        top: 60px;
      }

      .input-block {
        width: 50vw;
        max-width: 750px;
        position: relative;
        top: 50px;
        display: flex;
        align-items: center;

        @media screen and (max-width:1050px) {
          width: calc(100vw - 90px);
        }

        @media screen and (max-width:520px) {
          width: calc(100vw - 120px);
        }

        .ant-select-selection {
          border-radius: 50px;
          height: 40px;
          width: 120px;
          @media screen and (max-width:1050px) {
            height: 40px;
            z-index: 1;
            font-size: 12px;
            width: 100px;
          }
          @media screen and (max-width:520px) {
            height: 30px;
            z-index: 1;
            font-size: 12px;
            width: 80px;
          }
        }
        .ant-select-selection__rendered {
          display: flex;
          justify-content: center;
          width: 120px;
          line-height: 40px;
          text-align: center;
          margin: 0;
          // margin-left: -10px;
          @media screen and (max-width:520px) {
            line-height: 30px;
          }
          @media screen and (max-width:1050px) {
            height: 30px;
            font-size: 12px;
            width: 80px;
          }
        }
        .ant-select {
          position: absolute;
          left: 37px;
          // background-color: rgba(255, 255, 255, 0.5);
          z-index: 1;
          font-size: 17px;

          @media screen and (max-width:520px) {
            height: 30px;
            top: -5px;
            left: 37px;
            z-index: 1;
            font-size: 12px;
            text-align: center;
            width: max-content;
          }
          @media screen and (max-width:500px) {
            height: 30px;
            top: -5px;
            left: 16px;
            z-index: 1;
            font-size: 12px;
            text-align: center;
            width: max-content;
          }
        }

        input {
          position: absolute;
          width: 100%;
          background-color: rgba(255, 255, 255, 0.5);
          padding-top: 15px;
          padding-bottom: 15px;
          padding-left: 140px;
          padding-right: 100px;
          height: 50px;
          border-radius: 50px;
          font-size: 17px;

          @media screen and (max-width:1050px) {
            background-color: rgba(255, 255, 255, 0.8);
            padding-top: 15px;
            padding-bottom: 15px;
            padding-left: 120px;
            padding-right: 150px;
            height: 50px;
            font-size: 13px;
          }

          @media screen and (max-width:520px) {
            padding-top: 15px;
            padding-bottom: 15px;
            padding-left: 100px;
            padding-right: 75px;
            height: 40px;
            border-radius: 50px;
          }
        }

        .m-button {
          background: var(--head-line);
          color: #FFFFFF;
          border-radius: 50px;
          position: absolute;
          right: -24px;
          height: 40px;
          top: -10px;

          @media screen and (max-width:520px) {
            height: 30px;
            font-size: 12px;
            width: 60px !important;
            top: -5px;
          }
          @media screen and (max-width:500px) {
            height: 30px;
            font-size: 12px;
            width: 60px !important;
            top: -5px;
            right: -5px;  
          }
          // @media screen and (max-width:400px) {
          //   height: 30px;
          //   font-size: 12px;
          //   width: 60px !important;
          //   top: -5px;
          //   right: -35px;  
          // }
        }
      }

      .select-block {
        position: relative;
        top: 130px;
        left: 20px;

        @media screen and (max-width:1050px) {
          left: 10px;
          top: 120px;
        }

        @media screen and (max-width:520px) {
          top: 100px;
        }

        div {
          display: flex;
          gap: 30px;
          height: 50px;
          align-items: center;
          line-height: 50px;
          p {
            margin-bottom: 0 !important;
          }
          

          @media screen and (max-width:1050px) {
            gap: 15px;
          }

          @media screen and (max-width:520px) {
            gap: 7px;
          }

          p {
            font-size: 20px;
            color: var(--head-line);
            font-weight: 700;

            @media screen and (max-width:1050px) {
              font-size: 13px;
            }
          }

          @media screen and (max-width:520px) {
            input {
              height: 30px;
              font-size: 12px;
              width: 100px !important;
            }
          }
        }
      }
    }

    .title {
      font-size: 64px;
      color: var(--head-line);
      font-weight: 700;

      @media screen and (max-width:1050px) {
        width: 40vw;
        word-wrap: break-word;
        font-size: 50px;
      }

      @media screen and (max-width:520px) {
        width: 37vw;
        word-wrap: break-word;
        font-size: 30px;
      }
    }

    .main-img {
      position: absolute;
      right: 150px;
      z-index: 0;

      @media screen and (max-width:1050px) {
        right: 10px;
        width: 60%;
        min-width: 239px;
      }
    }
  }

  .hot-list {
    height: 310px;
    margin-top: 100px;
    padding-left: 100px;
    padding-right: 100px;
    @media screen and (max-width:1050) {
    
      padding-left: 50px;
      padding-right: 50px;
    }
    @media screen and (max-width:873px) {
      
      padding-right: 15px;
      padding-left: 15px;
    }

    @media screen and (max-width:622px) {
      margin-top: 150px;
      padding-right: 15px;
      padding-left: 15px;
    }


    p {
      // padding-left: 100px;
      font-size: 20px;
      color: var(--head-line);
      font-weight: 700;

      @media screen and (max-width:1050px) {
        // padding-left: 30px;
        font-size: 25px;
        color: var(--head-line);
        font-weight: 700;
      }

      @media screen and (max-width:520px) {
        font-size: 20px;
        // padding-left: 15px;
      }
    }

    .img-wrapper {
      width: 90vw;

      padding: 40px 20px;
      height: 300px;
      margin: auto;
      margin-top: 20px;
      display: flex;
      overflow-x: auto;
      /* 显示水平滚动条 */
      white-space: nowrap;

      /* 防止换行 */
      @media screen and (max-width:1050px) {
        width: calc(100vw - 60px);
        padding: 10px 15px;
      }

      @media screen and (max-width:520px) {
        width: calc(100vw - 30px);
        padding: 10px 15px;
      }

      img {
        width: 100%;
        min-width: 130px;
      }

      .bigger {
        transition: transform 0.5s ease-in-out;
        transform: scale(1.2);
      }
    }
  }

  .news-list {
    margin-top: 100px;
    margin-bottom: 100px;
    padding-left: 100px;
    padding-right: 100px;

    @media screen and (max-width:1050px) {
      margin-top: 100px;
      margin-bottom: 50px;
      padding-left: 100px;
      padding-right: 100px;
    }

    @media screen and (max-width:873px) {
      padding-right: 15px;
        padding-left: 15px;
    }

    @media screen and (max-width:520px) {
      margin-top: 80px;
      margin-bottom: 50px;
      padding-right: 15px;
        padding-left: 15px;
    }

    .top {
      display: flex;
      height: 350px;
      @media screen and (max-width:520px) {
        height: 350px;
      }
    }

    .calender {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-right: 5px solid #b7b7b7;
      width: 50vw;
      max-width: max-content;
      padding-right: 100px;

      @media screen and (max-width:1050px) {
        padding-right: 50px;
        
      }

      @media screen and (max-width:520px) {
        padding-right: 30px;
        width: 40vw;
      }

      p {
        font-size: 70px;
        color: var(--head-line);
        font-weight: 900;
        margin-bottom: 0px !important;
        @media screen and (max-width:850px) {
          font-size: 64px;
        }

        @media screen and (max-width:520px) {
          font-size: 46px;
        }
      }
    }

    .news {
      width: 50vw;
      padding-left: 40px;
      padding-right: 0;
      padding-top: 10px;

      @media screen and (max-width:520px) {
        padding-left: 18px;
        padding-top: 18px;
        padding-right: 0;
        width: 100%;
        height: 350px;
        overflow-y: scroll;
      }

      @media screen and (max-width:1050px) {
        width: 100%;
        padding-left: 25px;
      }

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        p {
          text-decoration: underline;
          cursor: pointer;

          @media screen and (max-width:950px) {
            display: none;
          }
        }

        .m-button {
          color: var(--head-line);
          cursor: default;

          @media screen and (max-width:520px) {
            font-size: 12px;
            width: 80%;
          }
        }
      }

      .news-item {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;

        p {
          margin-bottom: 0 !important;
        }

        @media screen and (max-width:1170px) {
          font-size: 12px;
        }

        @media screen and (max-width:955px) {
          width: 100%;
        }

        .desc {
          text-decoration: underline;
          color: #1B2D45;

          @media screen and (max-width:955px) {
            width: 90%;
            font-size: 15px;
          }

          @media screen and (max-width:520) {
            font-size: 12px;
          }
        }

        .time {
          color: #868686;

          @media screen and (max-width:955px) {
            display: none;
          }
        }
      }
    }

    .recommend {
      margin-top: 50px;

      .head {
        height: 30px;
        display: flex;
        gap: 30px;
        align-items: center;
        margin-bottom: 20px;
        .m-button {
          color: var(--head-line);
          cursor: default;

          @media screen and (max-width:520px) {
            font-size: 12px;
            width: 110px;
          }
        }

        div {
          display: flex;
          align-items: center;
          gap: 5px;
          user-select: none;
          cursor: pointer;
          &:hover {
            transform: scale(1.1);
          }
        }

        @media screen and (max-width:950px) {
          gap: 15px;
          font-size: 13px;
        }
      }

      .recommend-wrapper {
        width: 100%;
        margin: auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 50px;

        @media screen and (max-width:950px) {
          width: calc(100vw - 60px);
          background: #FFFFFF;
          border-radius: 12px;
          padding: 10px 10px;
          border: 1px solid #C4C4C4;
          margin: auto;
          margin-top: 20px;
          display: flex;
          flex-wrap: nowrap;
          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
          overflow-x: auto;
          /* 显示水平滚动条 */
          white-space: nowrap;
          /* 防止换行 */
        }

        @media screen and (max-width:520px) {
          width: calc(100vw - 40px);
        }

        .div {
          width: 25%;
          max-width: 300px;
          position: relative;
          background: #FFFFFF;
          border-radius: 12px;
          box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 244px;
          }
        }

        .book-name {
          height: 60px;
          line-height: 60px;
          text-align: center;
          font-weight: 700;
        }
      }
    }
  }

}
.loading1 {
  position: relative;
}

.loading1:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 30px solid #f3f3f3; /* 调整边框大小 */
  border-top: 30px solid #3498db;/* 调整顶部边框大小 */
  border-radius: 50%;
  width: 30px ; /* 调整宽度 */
  height: 30px ; /* 调整高度 */
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

</style>
